export const tabsSalesCharts = [
  {
    name: 'Top Gestiones por Mes',
    value: 0,
    dataName: 'topGestionesByMonth',
    typeValue: 'YYYY-MM',
    label: 'gestion',
    legend: 'Top Gestiones',
  },
  {
    name: 'Top Gestiones por Día',
    value: 1,
    dataName: 'topGestionesByDay',
    typeValue: 'YYYY-MM-DD',
    label: 'gestion',
    legend: 'Top Gestiones',
  },
  {
    name: 'Asistencia Manual Mensual',
    value: 2,
    dataName: 'stopByMonth',
    typeValue: '[0]',
    label: 'month',
    legend: 'Asistencia Manual',
  },
  {
    name: 'Asistencia Manual Diaria',
    value: 3,
    dataName: 'stopByDay',
    typeValue: 'YYYY-MM',
    label: 'day',
    legend: 'Asistencia Manual',
  },
  // {
  //   name: 'Chats Mensuales por Año',
  //   value: 4,
  //   dataName: 'chatsByMonth',
  //   typeValue: '[0]',
  //   label: 'month',
  //   legend: 'Chats',
  // },
  {
    name: 'Chats Diarios por Mes',
    value: 5,
    dataName: 'chatsByDay',
    typeValue: 'YYYY-MM',
    label: 'day',
    legend: 'Chats',
  },
];
export const tabsHealthDecisionCharts = [
  {
    name: 'Top Gestiones por Mes',
    value: 0,
    dataName: 'topGestionesByMonth',
    typeValue: 'YYYY-MM',
    label: 'gestion',
    legend: 'Top Gestiones',
  },
  {
    name: 'Top Gestiones por Día',
    value: 1,
    dataName: 'topGestionesByDay',
    typeValue: 'YYYY-MM-DD',
    label: 'gestion',
    legend: 'Top Gestiones',
  },
  // {
  //   name: 'Chats Mensuales por Año',
  //   value: 2,
  //   dataName: 'chatsByMonth',
  //   typeValue: '[0]',
  //   label: 'month',
  //   legend: 'Chats',
  // },
  {
    name: 'Chats Diarios por Mes',
    value: 3,
    dataName: 'chatsByDay',
    typeValue: 'YYYY-MM',
    label: 'day',
    legend: 'Chats',
  },
];
